var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 9.99967C2.08325 6.26772 2.08325 4.40175 3.24262 3.24237C4.40199 2.08301 6.26797 2.08301 9.99992 2.08301C13.7318 2.08301 15.5978 2.08301 16.7573 3.24237C17.9166 4.40175 17.9166 6.26772 17.9166 9.99967C17.9166 13.7316 17.9166 15.5976 16.7573 16.757C15.5978 17.9163 13.7318 17.9163 9.99992 17.9163C6.26797 17.9163 4.40199 17.9163 3.24262 16.757C2.08325 15.5976 2.08325 13.7316 2.08325 9.99967Z",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 8.33301C6.39289 8.33301 5.83325 7.77337 5.83325 7.08301C5.83325 6.39265 6.39289 5.83301 7.08325 5.83301C7.77361 5.83301 8.33325 6.39265 8.33325 7.08301C8.33325 7.77337 7.77361 8.33301 7.08325 8.33301Z",
    stroke: "#616874",
    strokeWidth: 1.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 14.166C13.6071 14.166 14.1667 13.6063 14.1667 12.916C14.1667 12.2257 13.6071 11.666 12.9167 11.666C12.2264 11.666 11.6667 12.2257 11.6667 12.916C11.6667 13.6063 12.2264 14.166 12.9167 14.166Z",
    stroke: "#616874",
    strokeWidth: 1.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 7.08301H14.1666",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 12.916H5.83325",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselOptions);
export default __webpack_public_path__ + "static/media/carousel-options.78bf8aa70b4ccc732ebca85557bb509b.svg";
export { ForwardRef as ReactComponent };